import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'csi-birthday-picker-form-field',
  templateUrl: './birthday-picker-form-field.component.html',
  styleUrls: ['./birthday-picker-form-field.component.css']
})
export class BirthdayPickerFormFieldComponent {
  @Input() control: FormControl;
  // Pass-through to csi-birthday-picker: hosts inside an overflow:auto container pass 'body'
  // so the month/day/year panels cannot be clipped or spawn container scrollbars.
  @Input() appendDropdownsTo: string = null;
  // Transloco key shown as an info icon until the control holds a valid date.
  @Input() hintKey = '';
}
